import { buildSearchParams } from "../utils/requestHelpers";
import shotClockRepository from "../repositories/ShotClockRepository";

export class ShotClockService {
  static LockLoad(instance, movementId, orderId) {
    const repo = new shotClockRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
      }
    );

    return repo.lockLoad(instance, params, orderId);
  }

  static UnlockLoad(instance, movementId) {
    const repo = new shotClockRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
      }
    );

    return repo.unlockLoad(instance, params);
  }

  static GetLockedLoads(instance) {
    const repo = new shotClockRepository;

    return repo.getLockedLoads(instance);
  }

  static GetPendingLocks(instance, movementId) {
    const repo = new shotClockRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
      }
    );

    return repo.getPendingLocks(instance, params);
  }

  static AddPendingLock(instance, movementId, userId) {
    const repo = new shotClockRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
        userId: userId
      }
    );

    return repo.addPendingLock(instance, params).then();
  }

  static RemovePendingLock(instance, movementId, userId) {
    const repo = new shotClockRepository;
    const params = buildSearchParams(
      {
        movementId: movementId,
        userId: userId
      }
    );

    return repo.removePendingLock(instance, params).then();
  }
}
